/** GLP-1 program sign-up Typeform. */
export const GLP_SIGNUP_TYPEFORM_ID = 'aeK9jORW';

export const GLP_SIGNUP_TYPEFORM_URL =
  'https://form.typeform.com/to/aeK9jORW';
